import axios from "axios";
import consts from "./consts";

export default async () => {
	const instance = axios.create({
		baseURL: consts.API_BASE_URL,
		timeout: 5000
	});
	return instance;
};
